import React from 'react';

import Row1_Col1_Img_1 from '../../../Images/gallery/betvip2/row-1_col-1_img-1.png';
import Row1_Col2_Img_1 from '../../../Images/gallery/betvip2/row-1_col-2_img-1.png';
import Row1_Col2_Img_2 from '../../../Images/gallery/betvip2/row-1_col-2_img-2.png';
import Row1_Col3_Img_1 from '../../../Images/gallery/betvip2/row-1_col-3_img-1.png';

import Row2_Col1_Img_1 from '../../../Images/gallery/betvip2/row-2_col-1_img-1.png';
import Row2_Col1_Img_2 from '../../../Images/gallery/betvip2/row-2_col-1_img-2.png';
import Row2_Col1_Img_3 from '../../../Images/gallery/betvip2/row-2_col-1_img-3.png';
import Row2_Col2_Img_1 from '../../../Images/gallery/betvip2/row-2_col-2_img-1.png';
import Row2_Col3_Img_1 from '../../../Images/gallery/betvip2/row-2_col-3_img-1.png';
import Row2_Col3_Img_2 from '../../../Images/gallery/betvip2/row-2_col-3_img-2.png';
import Row2_Col3_Img_3 from '../../../Images/gallery/betvip2/row-2_col-3_img-3.png';

import ZageImg from '../../../Images/gallery/betvip2/row-3_col-1_img-1.png';

export const Betvip_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>BETVIP</span>,
  },
];

export const Title_1 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>BETVIP ZAGUE</span>,
  },
];

export const Title_2 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>BETVIP Angelique y Sebastián</span>,
  },
];

export const Title_3 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FOTO FIJA</span>,
  },
];

export const Gallery_images = [
  { id: 1, src: Row1_Col1_Img_1, colSpan: 2, rowSpan: 6 },
  { id: 2, src: Row1_Col2_Img_1, colSpan: 1, rowSpan: 3 },
  { id: 3, src: Row1_Col3_Img_1, colSpan: 2, rowSpan: 6 },
  { id: 4, src: Row1_Col2_Img_2, colSpan: 1, rowSpan: 3 },
  { id: 5, src: Row2_Col1_Img_1, colSpan: 1, rowSpan: 3 },
  { id: 8, src: Row2_Col2_Img_1, colSpan: 3, rowSpan: 9 },
  { id: 9, src: Row2_Col3_Img_1, colSpan: 1, rowSpan: 3 },
  { id: 6, src: Row2_Col1_Img_2, colSpan: 1, rowSpan: 3 },
  { id: 10, src: Row2_Col3_Img_2, colSpan: 1, rowSpan: 3 },
  { id: 7, src: Row2_Col1_Img_3, colSpan: 1, rowSpan: 3 },
  { id: 11, src: Row2_Col3_Img_3, colSpan: 1, rowSpan: 3 },
  { id: 12, src: ZageImg, colSpan: 5, rowSpan: 12 },
];
